import type {
    CallPlayerConfig,
    CloudFlarePlayerConfig,
    IvsRealTimePlayerConfig,
    MockPlayerConfig,
    StripChatPlayerConfig,
} from '$lib/services/streaming/types';

import type { StreamPlayerConfig } from '@api/types';
import { getCookie } from '@components/utils/cookies';
import { Cookie } from '@shared/cookies';
import { StreamProvider } from '@shared/types/room';

import type { PartnerStreamStoreState } from '../partner-stream/types';

type Config = StripChatPlayerConfig
    | CloudFlarePlayerConfig
    | CallPlayerConfig
    | IvsRealTimePlayerConfig
    | MockPlayerConfig

export function streamToConfig(
    stream: StreamPlayerConfig,
    userId: string,
    roomId: string
): Config {
    const configFromCookie =
                getCookie(Cookie.QaTest) === 'true' && getCookie(Cookie.StreamingProvider);
    if (configFromCookie === StreamProvider.MockProvider) {
        return {
            provider: StreamProvider.MockProvider,
        };
    }
    if (stream.stripchat && stream.stripchat.id) {
        return {
            provider: StreamProvider.StripChat,
            id: stream.stripchat.id,
            origin: stream.stripchat.origin,
        };
    }

    if (stream.cloudflare && stream.cloudflare.playUrl) {
        return {
            provider: StreamProvider.CloudFlare,
            playUrl: stream.cloudflare.playUrl,
        };
    }

    if (stream.cloudflareCall && stream.cloudflareCall.sessionId) {
        return {
            provider: StreamProvider.CloudFlareCalls,
            sessionId: stream.cloudflareCall.sessionId,
            tracks: stream.cloudflareCall.tracks,

        };
    }

    if (stream.ivsRealtime && stream.ivsRealtime.stageArn) {
        return {
            provider: StreamProvider.IvsRealTime,
            userId: userId,
            roomId,
        };
    }
    throw new Error('Unsupported stream configuration');
}

export function extractStreamId(playerState: PartnerStreamStoreState | null) {
    const configFromCookie =
                getCookie(Cookie.QaTest) === 'true' && getCookie(Cookie.StreamingProvider);
    if (configFromCookie === StreamProvider.MockProvider) {
        return "mock-provider";
    }
    return playerState?.stream.cloudflareCall?.sessionId
        ? playerState.stream.cloudflareCall.sessionId
        : playerState?.stream.cloudflare?.playUrl
            ? playerState?.stream.cloudflare?.playUrl
            : playerState?.stream.stripchat?.id
                ? playerState?.stream.stripchat?.id
                : playerState?.stream.ivsRealtime?.stageArn;
}